import AbstractPartnershipModel from './AbstractPartnershipModel';
import doc                      from '@widesk-core/decorators/doc';
import { RenderNameProps }      from '@widesk-ui/mixins/ApiModelRenderName';
import { Translatable }         from '@widesk-core/decorators/translatable';
import appStore                 from '@/stores/appStore';
import { computed }             from 'mobx';
import EntityModel              from '@models/fondations/EntityModel';

@doc.urnResource('partnership')
@doc.translatable({ title: true, excerpt: true, content: true })
class PartnershipModel extends AbstractPartnershipModel {
	@doc.modelUrn(EntityModel) declare entity: EntityModel;

	public get pagePathPrefix() {
		return `/website_entertainments/${this.get('websiteEntertainment.id')}`;
	}

	public renderName(props?: RenderNameProps<this> & PartnershipNameProps) {
		return super.renderName(props);
	}

	static get urlPrefix() {
		return `${appStore.websiteEntertainment?.url}/partenaires/`;
	}

	getUrl(complete = false) {
		const path = PartnershipModel.urlPrefix + this.slug;
		if (complete) {
			return appStore.websiteEntertainment?.website.url + path;
		}

		return path;
	}

	get status() {
		return this.partnershipStatus;
	}

	@computed get contentToPublish() {
		return appStore.collContentToPublish
			.find(m => m.objectUrn === this.urn) || undefined;
	}

	get isPublishScheduled() {
		return this.contentToPublish?.contentToPublishStatus.reference === 'ENABLED';
	}
}

interface PartnershipModel
	extends Translatable<{ excerpt: true, title: true, content: true }> {
}

export default PartnershipModel;